(function () {
	const header = () => {
		const header = document.querySelector(".shopify-section-header");
		const menu = document.querySelector(".list-menu--inline");
		const menuLinks = document.querySelectorAll(".list-menu-item");
		const search = document.querySelector(".header__search");

		header.addEventListener("keydown", (e) => {
			if (e.code === "Escape" && search.isOpen) {
				search.close();
			}
		});

		const annBar = document.querySelector(".section-announcement");
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries;

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					"--ann-height",
					`${entry.intersectionRect.height}px`,
				);
			} else {
				document.documentElement.style.setProperty("--ann-height", `0px`);
			}
		});
		if (annBar) annBarObserver.observe(annBar);

		const megaMenus = document.querySelectorAll(".mega-menu");

		// 初始化清理状态
    // menuLinks.forEach((link) => {
		// 	link.classList.remove("list-menu--megamenu-visible");
		// });

		menuLinks.forEach((link) => {
			link.addEventListener("mouseenter", (e) => {
				if (link.classList.contains("list-menu--megamenu")) {
					link.classList.add("list-menu--megamenu-visible");

					if (!megaMenus) return;
					megaMenus.forEach((megaMenu) => {
						const megaMenuPositionRight =
							megaMenu.getBoundingClientRect().right;
						const windowRight = window.innerWidth;
						if (megaMenuPositionRight > windowRight) {
							megaMenu.style.right = "0";
						}
						if (megaMenu == link.querySelector('.mega-menu')) {
							megaMenu.style.opacity = 0;
							megaMenu.style.display = "block";
							setTimeout(() => {
								megaMenu.style.opacity = 1;
							}, 100);
						}
					});

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove("list-menu--megamenu-visible");
						}
					});
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove("list-menu--megamenu-visible");
					});
				}
			});
			link.addEventListener("mouseleave", (e) => {
				if (link.classList.contains("list-menu--megamenu")) {
					if (!megaMenus) return;
					megaMenus.forEach((megaMenu) => {
						if (megaMenu == link.querySelector('.mega-menu')) {
							megaMenu.style.opacity = 0;
							setTimeout(() => {
								megaMenu.style.display = "none";
							}, 300);
						}
					});
				}
			})
			link.addEventListener("focus", (e) => {
				if (link.classList.contains("list-menu--megamenu")) {
					link.classList.add("list-menu--megamenu-visible");

					if (!megaMenus) return;
					megaMenus.forEach((megaMenu) => {
						const megaMenuPositionRight =
							megaMenu.getBoundingClientRect().right;
						const windowRight = window.innerWidth;
						if (megaMenuPositionRight > windowRight) {
							megaMenu.style.right = "0";
						}
					});

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove("list-menu--megamenu-visible");
						}
					});
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove("list-menu--megamenu-visible");
					});
				}
			});
		});
		menu.addEventListener("mouseleave", (e) => {
			if (!megaMenus) return;
			setTimeout(() => {
				megaMenus.forEach((megaMenu) => {
					megaMenu.style.right = "auto";
				});
			}, 500);
			menuLinks.forEach((link) => {
				link.classList.remove("list-menu--megamenu-visible");
			});
		});
		menu.addEventListener("focusout", (e) => {
			if (!megaMenus) return;
			setTimeout(() => {
				megaMenus.forEach((megaMenu) => {
					megaMenu.style.right = "auto";
				});
			}, 500);
			menuLinks.forEach((link) => {
				// link.classList.remove("list-menu--megamenu-visible");
			});
		});

		// const megaMenuTabs = () => {
		// 	$(".mega-menu__tab-wrapper")
		// 		.children()
		// 		.find(".mega-menu__tab-wrapper")
		// 		.first()
		// 		.addClass("mega-menu__tab-wrapper--active");
		// 	$(".mega-menu__tab-wrapper").mouseenter(function (event) {
		// 		$(".mega-menu__tab-wrapper").removeClass(
		// 			"mega-menu__tab-wrapper--active",
		// 		);
		// 		$(this).addClass("mega-menu__tab-wrapper--active");
		// 	});
		// 	$(".mega-menu__tab-wrapper").focus(function (event) {
		// 		$(".mega-menu__tab-wrapper").removeClass(
		// 			"mega-menu__tab-wrapper--active",
		// 		);
		// 		$(this).addClass("mega-menu__tab-wrapper--active");
		// 	});
		// 	$(".mega-menu__tab-wrapper").focusin(function (event) {
		// 		$(".mega-menu__tab-wrapper").removeClass(
		// 			"mega-menu__tab-wrapper--active",
		// 		);
		// 		$(this).addClass("mega-menu__tab-wrapper--active");
		// 	});
		// };
		// megaMenuTabs();

		const megaMenuTabs = () => {
			// 公共事件绑定函数
			const activateTab = (event) => {
				// 获取当前 tab 的索引值
				const tabIndex = $(event.currentTarget).index();
		
				// 激活当前 tab，移除其他 tab 的 active 类
				$(".mega-menu__tab-wrapper").removeClass("mega-menu__tab-wrapper--active");
				$(event.currentTarget).addClass("mega-menu__tab-wrapper--active");
		
				// 激活对应的内容，移除其他内容的 active 类
				$(".mega-menu__tab-content").removeClass("active");
				$(".mega-menu__tab-content").eq(tabIndex).addClass("active");
			};
		
			// 绑定鼠标移入事件
			$(".mega-menu__tab-wrapper").on("mouseenter", activateTab);
		
			// 绑定键盘焦点事件（兼容无障碍设计）
			$(".mega-menu__tab-wrapper").on("focus focusin", activateTab);
		};
		// 调用函数
		megaMenuTabs();

		const typeTitleTabs = () => {
			// 绑定点击事件
			$(".type-title-item").on("click", function () {
				const $this = $(this);
				const $parentWrapper = $this.closest(".type-title-list"); // 找到当前标题的父容器
				const index = $parentWrapper.find(".type-title-item").index($this); // 获取当前点击项的索引
		
				// 先移除同父级子元素的 active 类，再为当前点击项添加 active 类
				$parentWrapper.find(".type-title-item").removeClass("active");
				$this.addClass("active");
		
				// 找到对应的 type-product-list 并切换 active 类
				const $productListWrapper = $this.closest(".mega-menu__tab-content"); // 找到包含 type-title-list 的上级内容区
				const $targetProductList = $productListWrapper.find(".type-product-list").eq(index); // 根据索引找到目标产品列表
		
				// 移除兄弟产品列表的 active 类，仅为目标列表添加 active 类
				$productListWrapper.find(".type-product-list").removeClass("active");
				$targetProductList.addClass("active");
			});
		};
		
		// 调用函数
		typeTitleTabs();

		// 手机端
		const toggleTabContent = () => {
			$("#menu-drawer .mega-menu__tab-info").on("click", function () {
				const $this = $(this); // 当前点击的元素
				const $tabWrapper = $this.closest(".mega-menu__tab"); // 找到当前元素的父级 .mega-menu__tab
				const $tabContent = $tabWrapper.find(".mega-menu__tab-content"); // 找到对应的内容区域
		
				// 如果当前已经有 active 类，移除 active 类并隐藏内容
				if ($this.hasClass("active")) {
					$this.removeClass("active");
					$tabContent.hide();
				} else {
					// 如果当前没有 active 类，添加 active 类并显示内容
					$this.addClass("active");
					$tabContent.show();
				}
			});
		};
		
		// 调用函数
		toggleTabContent();
		
		const main = document.querySelector("main");
		const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
		if (
			main.querySelectorAll(".shopify-section")[0] &&
			main
				.querySelectorAll(".shopify-section")[0]
				.classList.contains("section--has-overlay")
		) {
		}

		const menuCloseBtn = document.querySelector(".header__modal-close-button");
		const mobileMenuDrawer = document.querySelector("header-drawer");
		menuCloseBtn.addEventListener("click", (e) => {
			mobileMenuDrawer.closeMenuDrawer(e);
			console.log('123')
		});
	};

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);

	header();
})();
